export default function Auction({ data }) {
  return (
    <div>
      <h2 className="text-yellow-200 mb-3">Auction</h2>

      {data?.bids?.map((bid, i) => (
        <div key={i} className="bg-gray-800 p-2 mb-2 rounded">
          {bid.trader} → ₹{bid.bid}
        </div>
      ))}
    </div>
  );
}